<template>
  <router-link tag="a" :to="to" class="breadcrumb">
    <span class="breadcrumb__arrow">&#706;</span>
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.breadcrumb {
  font-family: $font-family-muli;
  font-weight: 600;
  color: $color-accent;
  color: var(--color-accent, $color-accent);
  &__arrow {
    margin-right: 18px;
  }
}
</style>
